import React, { useState, useEffect } from 'react';
import './PlantationOneArrival.scss';
import { useCollection } from '../../../../firebase-files/hooks/useCollection';
import { useNavigate } from 'react-router-dom';
import { FaTree, FaLeaf } from 'react-icons/fa';
import { useAuthContext } from '../../../../firebase-files/hooks/useAuthContext';
import firebase from 'firebase/app';
import 'firebase/firestore';

const PlantationOneArrivalSection = () => {
  const { documents: products } = useCollection('products');
  const { documents: settings } = useCollection('settings');
  const { user } = useAuthContext();
  const navigate = useNavigate();

  const [startIndex, setStartIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const visibleCount = isMobile ? 1 : 3;

  const [editingTitle, setEditingTitle] = useState(false);
  const [newTitle, setNewTitle] = useState('');
  const [savingTitle, setSavingTitle] = useState(false);

  const headingDoc = settings?.find(doc => doc.id === 'arrivalHeading');
  const headingText = headingDoc?.title || 'New Green Arrivals';

  const arrivals = products?.filter(product => product.newArrivals === true) || [];
  const visibleItems = arrivals.slice(startIndex, startIndex + visibleCount);
    const [loadedImages, setLoadedImages] = useState({});
     const handleImageLoad = (id) => {
    setLoadedImages(prev => ({ ...prev, [id]: true }));
  };


  // Enable auto-play
  useEffect(() => {
    const loadImages = async () => {
      await Promise.all(
        arrivals.map(item => {
          return new Promise((resolve) => {
            const img = new Image();
            img.src = Array.isArray(item.images) 
              ? item.images[0] || '/fallback-image.jpg' 
              : item.images || '/fallback-image.jpg';
            img.onload = () => {
              handleImageLoad(item.id);
              resolve();
            };
            img.onerror = () => resolve();
          });
        })
      );
    };
    
    if (arrivals.length) loadImages();
  }, [arrivals]);

   useEffect(() => {
    if (arrivals.length > 0) {
      arrivals.forEach(item => {
        const img = new Image();
        img.src = Array.isArray(item.images) 
          ? item.images[0] || '/fallback-image.jpg' 
          : item.images || '/fallback-image.jpg';
      });
    }
  }, [arrivals]);

//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth < 768);
//     };

//     window.addEventListener('resize', handleResize);

//     let interval;
//     if (arrivals.length > visibleCount) {
//       interval = setInterval(() => {
//         setStartIndex(prev => (prev + 1) % (arrivals.length - visibleCount + 1));
//       }, 3000);
//     }

//     return () => {
//       window.removeEventListener('resize', handleResize);
//       if (interval) clearInterval(interval);
//     };
//   }, [isMobile, arrivals.length, visibleCount]);
useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);

    let interval;
    if (arrivals.length > visibleCount) {
      interval = setInterval(() => {
        setStartIndex(prev => (prev + 1) % (arrivals.length - visibleCount + 1));
      }, 3000);
    }

    return () => {
      window.removeEventListener('resize', handleResize);
      if (interval) clearInterval(interval);
    };
  }, [isMobile, arrivals.length, visibleCount]);

  const saveTitle = async () => {
    setSavingTitle(true);
    try {
      const db = firebase.firestore();
      await db.collection('settings').doc('arrivalHeading').set({ title: newTitle });
      setEditingTitle(false);
    } catch (err) {
      console.error('Error saving heading:', err);
    } finally {
      setSavingTitle(false);
    }
  };

  const handleNext = () => {
    if (startIndex + visibleCount < arrivals.length) {
      setStartIndex(prev => prev + 1);
    } else {
      setStartIndex(0);
    }
  };

  const handlePrev = () => {
    if (startIndex > 0) {
      setStartIndex(prev => prev - 1);
    } else {
      setStartIndex(arrivals.length - visibleCount);
    }
  };

  const handleShopClick = () => {
    navigate('/products?filter=new-arrivals');
  };

  const handleProductClick = (productId) => {
    if (productId) navigate(`/product-details-two/${productId}`);
  };

  const formatPrice = (value) => {
    return new Intl.NumberFormat('en-IN', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(value);
  };

  return (
    <section className="tree-arrival-section">
      <div className="tree-container">
        <div className="tree-header">
          <div className="tree-title-group">
            {user?.role === 'admin' && editingTitle ? (
              <div className="edit-title-box">
                <input
                  value={newTitle}
                  onChange={(e) => setNewTitle(e.target.value)}
                  placeholder="Enter new heading"
                />
                <button onClick={saveTitle} disabled={savingTitle}>
                  {savingTitle ? 'Saving...' : 'Save'}
                </button>
                <button onClick={() => setEditingTitle(false)}>Cancel</button>
              </div>
            ) : (
              <h2 className="tree-title">
                {headingText.split(' ').map((word, idx) =>
                  word.toLowerCase() === 'green' ? <span key={idx}>{word}</span> : ` ${word}`
                )}
                {user?.role === 'admin' && (
                  <button
                    style={{ marginLeft: 10, fontSize: 14 }}
                    onClick={() => {
                      setNewTitle(headingText);
                      setEditingTitle(true);
                    }}
                  >
                    ✏️
                  </button>
                )}
              </h2>
            )}
          </div>

          <p className="tree-description">
Each adoption plants a tree in your name. Help us grow a forest while you grow personally and leave a lasting legacy for the planet.          </p>
          {/* <button className="tree-shop-btn" onClick={handleShopClick}>
            <FaTree className="icon" />
            Adopt Tree
          </button> */}
        </div>

        <div className="tree-display-area">
          <div className="tree-product-scene">
            {!isMobile && (
              <div className="tree-background-elements">
                <div className="tree-silhouette left"></div>
                <div className="tree-silhouette right"></div>
                <div className="ground-line"></div>
              </div>
            )}

            <div className="tree-product-display">
              <button
                className="tree-nav-btn prev"
                onClick={handlePrev}
                disabled={arrivals.length <= visibleCount}
              >
                <span className="arrow"></span>
              </button>

              <div className="tree-product-cards">
                {visibleItems.map((item, index) => (
                  <div
                    className={`tree-card ${isMobile ? 'mobile-card' : `card-${index + 1}`}`}
                    key={item.id || index}
                    onClick={() => handleProductClick(item.id)}
                  >
                    <div className="card-eco-badge">
                      <FaLeaf />
                      <span>Adopts Tree</span>
                    </div>
                   <div className="card-image-container">
    {loadedImages[item.id] && (
      <img
        src={Array.isArray(item.images) ? item.images[0] || '/fallback-image.jpg' : item.images || '/fallback-image.jpg'}
        alt={item.name}
        style={{ opacity: 1 }}
      />
    )}
  </div>
                    <div className="card-details">
                      <h3>{item.name}</h3>
                      <div className="price-section">
                        {item.originalPrice && (
                          <span className="original-price">
                            ₹ {formatPrice(item.originalPrice)}
                          </span>
                        )}
                        <span className="current-price">
                          ₹ {formatPrice(item.price)}
                        </span>
                      </div>
                      <div className="eco-impact">
                        <FaTree className="icon" />
                        <span>You’ll be planting a {item.name || 'Neem'} tree</span>
                      </div>
                    </div>
                    
                  </div>
                  
                  
                ))}
              </div>

              <button
                className="tree-nav-btn next"
                onClick={handleNext}
                disabled={arrivals.length <= visibleCount}
              >
                <span className="arrow"></span>
              </button>
              
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PlantationOneArrivalSection;
